import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Job } from '../models/job';

@Injectable({
  providedIn: 'root',
})
export class JobService {
  private jobSource = new BehaviorSubject<Job | null>(null);
  currentJob = this.jobSource.asObservable();

  constructor() {}

  updateJob(job: Job) {
    this.jobSource.next(job);
  }
}
